import { useEffect } from "react";

import { Input, Label } from "neetoui";
import { useTranslation } from "react-i18next";

import DynamicQueryParams from "./DynamicQueryParams";
import SwitchOptions from "./SwitchOptions";

import useProductEmbedStore from "../useProductEmbedStore";

const Inline = ({
  customization,
  updateCustomization,
  otherCustomizations,
}) => {
  const { t } = useTranslation();
  const { isQueryParamsEnabled } = useProductEmbedStore.pick();

  const { elementSelector } = customization;

  const handleInputChange = ({ target: { value } }, attribute) =>
    updateCustomization({ [attribute]: value });

  useEffect(() => {
    if (isQueryParamsEnabled) return;

    updateCustomization({ queryParams: undefined });
  }, []);

  return (
    <>
      <div className="flex flex-col gap-2">
        <Label data-testid="inline-element-id-input-label">
          {t("neetoMolecules.productEmbed.inline.elementId")}
        </Label>
        <Input
          data-testid="inline-element-id-input-field"
          value={elementSelector}
          error={
            !elementSelector &&
            t("neetoMolecules.productEmbed.inline.elementIdError")
          }
          onChange={e => handleInputChange(e, "elementSelector")}
        />
      </div>
      <SwitchOptions {...{ customization, updateCustomization }} />
      {otherCustomizations()}
      {isQueryParamsEnabled && (
        <DynamicQueryParams {...{ updateCustomization }} />
      )}
    </>
  );
};

export default Inline;
